import { action as apiAction } from 'api/Api'

type Payload = {
  messageId: number
  message: any
}

export default (payload: Payload) => async () => {
  const { messageId, message } = payload

  await apiAction('EditCommentOnCard', {
    notificationId: messageId,
    rtMessage: message
  })
}
